import { NewsDetailContainer } from "../../containers";
import "./style.scss";
function NewsDetail() {
    return (
        <div id="newsdetail">
            <NewsDetailContainer />
        </div>
    );
}
export default NewsDetail;